import { render, staticRenderFns } from "./ShopColors.vue?vue&type=template&id=6b1a558a&scoped=true&"
import script from "./ShopColors.vue?vue&type=script&lang=js&"
export * from "./ShopColors.vue?vue&type=script&lang=js&"
import style0 from "./ShopColors.vue?vue&type=style&index=0&id=6b1a558a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a558a",
  null
  
)

export default component.exports